@if (playerNotesForm) {
  @if (inline) {
    <form
      class="form theme-form sc-notes-compose d-grid m-0"
      [formGroup]="playerNotesForm"
      (ngSubmit)="onSubmit()">
      <input
        type="text"
        #noteTitleInput
    id="noteColumnTitle"
        formControlName="title"
        class="sc-notes-title-input"
        autocomplete="off"
        [attr.maxlength]="maxLengths.TITLE"
        [attr.aria-label]="'players.notes.title' | translate"
        [placeholder]="'players.notes.title' | translate" />
      <textarea
        #noteContentInput
    id="noteColumnContent"
        formControlName="content"
        class="sc-notes-text-input"
        rows="1"
        [attr.maxlength]="maxLengths.CONTENT"
        [attr.aria-label]="'players.notes.label' | translate"
        [placeholder]="'players.notes.composerPlaceholder' | translate"></textarea>
    </form>
  } @else {
    <form [formGroup]="playerNotesForm" (ngSubmit)="onSubmit()">
      <div class="card-body">
        <div class="modal-body">
          <div class="form-group">
            <label for="title" class="form-label">
              {{ 'players.notes.title' | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              id="title"
              formControlName="title"
              class="form-control form-control-sm"
              [attr.maxlength]="maxLengths.TITLE"
              placeholder="{{ 'players.notes.titlePlaceholder' | translate }}" />
          </div>
          <div class="form-group mt-3">
            <label for="content" class="form-label">
              {{ 'players.notes.label' | translate }}
              <span class="text-danger">*</span>
            </label>
            <textarea
              id="content"
              formControlName="content"
              class="form-control"
              [attr.maxlength]="maxLengths.CONTENT"
              placeholder="{{ 'players.notes.placeholder' | translate }}"
              rows="4"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="closeModal()">
          {{ 'btn.cancel' | translate }}
        </button>
        <button type="submit" class="btn btn-secondary" [disabled]="playerNotesForm.invalid">
          {{ 'players.notes.agregateNote' | translate }}
        </button>
      </div>
    </form>
  }
}
